export type ManagedAssetDownloadRequest = {
  orgThreadLinkId: string;
  filename: string;
};

type ManagedAssetDownloadHandler = (
  request: ManagedAssetDownloadRequest
) => Promise<void>;

let activeHandler: ManagedAssetDownloadHandler | null = null;

export function registerManagedAssetDownloadHandler(
  handler: ManagedAssetDownloadHandler
): () => void {
  const previousHandler = activeHandler;
  activeHandler = handler;
  return () => {
    if (activeHandler === handler) activeHandler = previousHandler;
  };
}

export async function tryManagedAssetDownload(args: {
  assetType?: 'image' | 'video' | '3d';
  filename: string;
  trackingInfo?: { assetId: string; source: string };
}): Promise<boolean> {
  if (
    args.assetType !== 'video' ||
    args.trackingInfo?.source !== 'generate_thread_asset_tool' ||
    !activeHandler
  ) {
    return false;
  }
  await activeHandler({
    orgThreadLinkId: args.trackingInfo.assetId,
    filename: args.filename,
  });
  return true;
}
